import '../social/share-buttons';

import template from "./review.tpl";
import './review.css';

const Review = DomClass(template, function Review() {
	let disease = this.disease;

	this.starsString = function() {
		const english = ['zero', 'one', 'two', 'three', 'four', 'five'];
		const number = english[this.rating || 0];
		return this.rating == 1 ? (number + ' star') : (number + ' stars');
	};

	this.shareButtons.object = {
		description: disease.description,
		text: this.comment,
		tags: [
			disease.normalizedName,
			this.starsString(),
			'rate my disease'
		]
	};
});

export default Review;
